import logger from '../utils/logger';
import { DEV, MODE, VITE_API_URL } from '../env';

/**
 * Validates frontend configuration on startup
 * Fails fast with clear error messages if misconfigured
 */

export function validateConfig(): void {
  // In development mode, skip runtime config validation
  if (DEV) {
    if (VITE_API_URL) {
      logger.info('✅ Frontend Configuration Valid (Development):');
      logger.info(`   API_URL: ${VITE_API_URL}`);
      logger.info(`   Mode: ${MODE}`);
      return;
    } else {
      throw new Error('Development Configuration Error: VITE_API_URL not set in .env');
    }
  }

  // In production, check for runtime config from window.APP_CONFIG (set by docker-entrypoint.sh in multi-container setup)
  // In single-container setup, window.APP_CONFIG is undefined and we use same-origin (relative URLs)
  const config = window.APP_CONFIG || {};

  // If window.APP_CONFIG exists but has placeholder values, that's an error
  if (config.API_URL === '__API_URL__') {
    const errorMsg = '❌ CRITICAL: API_URL is a placeholder - docker-entrypoint.sh did not replace it';
    logger.error(errorMsg);
    logger.error('Found:', config);
    throw new Error('Configuration Error: API_URL placeholder not replaced');
  }

  // Log successful configuration
  if (config.API_URL) {
    // Multi-container setup with explicit API_URL
    logger.info('✅ Frontend Configuration Valid (Multi-Container):');
    logger.info(`   API_URL: ${config.API_URL}`);
  } else {
    // Single-container setup using same-origin (relative URLs)
    logger.info('✅ Frontend Configuration Valid (Single-Container):');
    logger.info('   API_URL: Same-origin (relative URLs)');
  }
  logger.info(`   Mode: ${MODE}`);
}
